import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useGetSettings } from "@/entities/settings";
import { useAuthContext } from "@/services/auth";
import { setDayJsLocale } from "@/services/dayjs";

import { handleFallbackAppLocale } from "./language.helper";

export const useLanguageHandler = () => {
  const { i18n } = useTranslation();
  const { hasToken } = useAuthContext();
  const { settings, isLoading } = useGetSettings({ enabled: hasToken });

  useEffect(() => {
    if (!isLoading && settings?.locale) {
      // On user locale change, uopdate i18n & dayjs
      i18n.changeLanguage(settings.locale);
      setDayJsLocale(settings.locale);
    }
  }, [isLoading, settings]);
};

export const useAppLocale = () => {
  const { i18n } = useTranslation();

  return handleFallbackAppLocale(i18n.language);
};
